export default __webpack_public_path__ + "static/how-hometown-works-icon-2-25ae4076807965c2d51c910c921f600d.png";